"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { ArrowLeft, Home, SearchX } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";

export default function NotFound() {
	const router = useRouter();
	const pathname = usePathname();

	const handleGoHome = () => {
		router.push("/");
	};

	const handleGoBack = () => {
		router.back();
	};

	return (
		<div className="flex flex-col items-center min-h-dvh px-4 py-12 relative overflow-hidden">
			{/* Decorative background elements */}
			<div className="absolute inset-0 overflow-hidden pointer-events-none">
				<div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
				<div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-chart-2/5 rounded-full blur-3xl" />
			</div>

			<div className="max-w-2xl w-full text-center grid grid-cols-1 grid-rows-[1fr_auto] gap-y-6 relative z-10 h-full">
				{/* Main Content */}
				<div className="grid grid-cols-1 gap-y-6 content-start">
					{/* Animated Icon */}
					<div className="flex justify-center">
						<div className="relative animate-in fade-in-0 zoom-in-95 duration-500">
							<div className="absolute inset-0 bg-primary/10 rounded-full blur-xl animate-pulse" />
							<div className="relative bg-linear-to-br from-primary/10 to-chart-2/5 rounded-lg size-16 flex flex-col items-center justify-center border border-primary/20">
								<SearchX className="size-10 text-primary" strokeWidth={1.5} />
							</div>
						</div>
					</div>

					{/* 404 Title */}
					<div className="space-y-3">
						<h1 className="text-sm font-medium tracking-[2px] uppercase text-primary">
							404
						</h1>
						<h2 className="text-4xl sm:text-5xl font-bold text-foreground leading-tight">
							Page Not Found
						</h2>
						<p className="text-sm text-muted-foreground max-w-md mx-auto">
							The page you&apos;re looking for doesn&apos;t exist or has been
							moved.
						</p>
					</div>

					{/* Current path info */}
					{pathname !== "/" && (
						<div className="bg-card/50 backdrop-blur-sm rounded-2xl p-6 border border-border shadow-lg">
							<div className="space-y-3">
								<div className="flex items-center justify-center gap-2 text-muted-foreground text-xs font-medium uppercase tracking-wider">
									<span className="size-2 bg-primary rounded-full animate-pulse" />
									Requested Path
								</div>
								<div className="bg-muted rounded-lg p-4">
									<p className="text-muted-foreground text-xs font-mono break-all text-left whitespace-pre-wrap">
										{pathname}
									</p>
								</div>
							</div>
						</div>
					)}

					{/* Action Buttons */}
					<div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
						<Button
							aria-label="Go to homepage"
							className="w-full sm:max-w-46"
							onClick={handleGoHome}
							tabIndex={0}
						>
							<Home />
							Go to Homepage
						</Button>
						<Button
							aria-label="Go back to previous page"
							className="w-full sm:max-w-46"
							onClick={handleGoBack}
							tabIndex={0}
							variant="ghost"
						>
							<ArrowLeft />
							Go Back
						</Button>
					</div>
				</div>

				{/* Help Text - Pushed to bottom */}
				<div className="text-muted-foreground text-sm font-light self-end">
					<p>
						If you believe this is an error, please{" "}
						<a
							className="text-primary hover:underline focus:outline-none focus:ring-2 focus:ring-primary/50 rounded transition-colors font-medium"
							href="mailto:support@propstrata.com"
							tabIndex={0}
						>
							contact our support team
						</a>{" "}
						for assistance.
					</p>
				</div>
			</div>
		</div>
	);
}
